import { Stack, Text, Title } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import { Logo } from '~/boggle/ui/atoms/Logo'
import { routeShellUi } from '~/boggle/ui/chrome/RouteShell'

/** Home hub hero: linked logo and site tagline (shared on landing and in-run on `/`). */
export function SiteHeroHeading() {
  return (
    <Stack component="section" gap={4} pb={28} pt="25vh" ta="center" w="100%">
      <Title m={0} order={1}>
        <Link className={routeShellUi.link} to="/">
          <Logo variant="hero" />
        </Link>
      </Title>
      <Text
        ff="Tilt Neon, sans-serif"
        fz={20}
        lh={1.3}
        opacity={1}
        ta="center"
        w="100%"
        c="#ffeaa8"
      >
        The fast-paced word game
      </Text>
    </Stack>
  )
}
